module.exports = __webpack_public_path__ + "img/rainy_little.456272b6.svg";